import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEvent  } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment} from '../../environments/environment';
import { Filter } from '../components/reports/filter';
import { Order } from '../components/reports/order';



@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  constructor(private http: HttpClient) { }
  urlEndPoint = environment.endPoint;

  getWards(): Observable<any> {
    return this.http.get<any>(this.urlEndPoint + '/api/wards');
  }

  searchOrders(filter: Filter): Observable<any> {
    const params = new URLSearchParams();
    params.set('startDate', filter.getStartDate());
    params.set('endDate', filter.getEndDate());
    params.set('state', filter.orderState.toString());

    filter.dni ? params.set('dni', filter.dni.toString()) : params.set('dni', '');
    filter.name ? params.set('name', filter.name) : params.set('name', '');
    filter.orderId ? params.set('orderid', filter.orderId.toString()) : params.set('orderId', '');
    filter.surname ? params.set('dni', filter.surname) : params.set('surname', '');


    return this.http.get<any>(this.urlEndPoint + '/api/oe/search-orders?' + params.toString());
  }

  getReports(orders: any): Observable<Blob> {
    return this.http.post(this.urlEndPoint + '/reports/get', orders , {responseType: 'blob'});
  }

  getResults(order: Order): Observable<any> {
    const params = new URLSearchParams();
    params.set('id', order.orderId);
    params.set('orderDate', order.orderDate);
    params.set('orderState', order.orderState.toString());
    return this.http.get<any>(this.urlEndPoint + '/results?' + params.toString() );
  }

  deleteOrder(order: Order): Observable<any> {
    const obj = {
      seqOrder: order.orderId,
      wardId: order.ward.wardId
      };
    // this.http.delete -> no soporta para enviar datos en body
    return this.http.request('delete', this.urlEndPoint + '/api/oe/order-delete', {body: obj} );
  }

}
